<script lang="ts">
import dayjs from 'dayjs'
import { computed, defineComponent } from 'vue'
import { l } from '../libs/localization'

export const dateFormat = (datetime: string | Date | dayjs.Dayjs, type: 'default' | 'full' | 'date') => {
  const d = dayjs(datetime)
  if (type === 'full') {
    return d.format(l('YYYY/MM/DD H:mm'))
  }
  if (type === 'date') {
    return d.format(l('YYYY/MM/DD'))
  }
  if (d.isToday()) {
    return d.format(l('H:mm'))
  }
  if (d.isSame(dayjs(), 'year')) {
    return d.format(l('M/D H:mm'))
  }
  return d.format(l('YYYY/MM/DD H:mm'))
}

export default defineComponent({
  props: {
    datetime: { type: [String, Date], required: true },
    full: { type: Boolean, default: false },
    date: { type: Boolean, default: false }
  },
  setup (props) {
    const output = computed(() => {
      const type = props.full ? 'full' : props.date ? 'date' : 'default'
      return dateFormat(props.datetime, type)
    })
    return {
      output
    }
  }
})
</script>

<template>
  {{ output }}
</template>
